import Tether from 'lib/tether';

export default class RawTether extends Tether {
  updateAttachClasses(elementAttach, targetAttach) {
    var add, all, side, sides, _i, _j, _len, _len1, _ref1;

    if (elementAttach == null) {
      elementAttach = this.attachment;
    }
    if (targetAttach == null) {
      targetAttach = this.targetAttachment;
    }
    sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
    if ((_ref1 = this._addAttachClasses) != null ? _ref1.length : void 0) {
      this._addAttachClasses.splice(0, this._addAttachClasses.length);
    }
    add = this._addAttachClasses != null ? this._addAttachClasses : this._addAttachClasses = [];
    if (elementAttach.top) {
      add.push("" + (this.getClass('element-attached')) + "-" + elementAttach.top);
    }
    if (elementAttach.left) {
      add.push("" + (this.getClass('element-attached')) + "-" + elementAttach.left);
    }
    if (targetAttach.top) {
      add.push("" + (this.getClass('target-attached')) + "-" + targetAttach.top);
    }
    if (targetAttach.left) {
      add.push("" + (this.getClass('target-attached')) + "-" + targetAttach.left);
    }
    all = [];
    for (_i = 0, _len = sides.length; _i < _len; _i++) {
      side = sides[_i];
      all.push("" + (this.getClass('element-attached')) + "-" + side);
    }
    for (_j = 0, _len1 = sides.length; _j < _len1; _j++) {
      side = sides[_j];
      all.push("" + (this.getClass('target-attached')) + "-" + side);
    }
  }

  move(position) {
    var classes = this._addAttachClasses;
    var targetClasses = [];
    var elementClasses = [];

    classes.forEach(function(c) {
      var cleaned = c.slice(7);

      if (cleaned.slice(0, 7) === 'element') {
        elementClasses.push(cleaned.slice(8));
      } else if (cleaned.slice(0, 6) === 'target') {
        targetClasses.push(cleaned.slice(7));
      }
    });

    this.options.onPosition(position, elementClasses, targetClasses);
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/RawTether.js
 **/